import { createFileRoute } from '@tanstack/react-router';

import { PostDetailPage } from '@/features/(insight)/posts/post-detail-page';

export const Route = createFileRoute('/workspace/$workspaceId/post/$postId')({
  component: PostDetailPage,
});
